import { useEffect, useState } from 'react';

export default function NumberInput({ value, onChange, placeholder, className }) {
    const [displayValue, setDisplayValue] = useState('');

    // Sync từ Formik → Input (chỉ khi form reset / load data)
    useEffect(() => {
        setDisplayValue(formatNumber(value));
    }, [value]);

    const handleChange = (e) => {
        const raw = e.target.value;
        const numberValue = parseNumber(raw);

        setDisplayValue(raw);      // giữ nguyên cái user đang gõ
        onChange(numberValue);     // đẩy number cho Formik
    };

    const handleBlur = () => {
        setDisplayValue(formatNumber(parseNumber(displayValue)));
    };
    const formatNumber = (value) => {
        if (value === null || value === undefined) return '';
        return new Intl.NumberFormat('vi-VN').format(value);
    };

    const parseNumber = (value) => {
        const onlyNumber = value.replace(/\D/g, '');
        return onlyNumber ? Number(onlyNumber) : '';
    };
    return (
        <input
            type="text"
            className={className ? className : "form-control height32"}
            value={displayValue}
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder={placeholder}
        />
    );
}
